<script setup type="ts">
import { CSidebarNav, CNavItem } from '@coreui/vue'

const nav = [
  {
    icon: 'cil-chart-pie',
    text: 'Dashboard',
    href: '/',
  },
  {
    icon: 'cil-dollar',
    text: 'Prestação de contas',
    href: '/prestacao-de-contas',
  },
  {
    icon: 'cil-book',
    text: 'Livro Diário Auxiliar',
    href: '/livro-diario-auxiliar',
  },
  {
    icon: 'cil-notes',
    text: 'Orçamentos',
    href: '/orcamentos',
  },
  {
    icon: 'cil-book',
    text: 'Livro de Depósito Prévio',
    href: '/deposito-previo',
  }
]
</script>

<template>
  <div>
    <CSidebarNav>

      <CNavItem href="/">
        <img src="/img/logo.png" alt="Logo" class="img-fluid logo">
      </CNavItem>

      <CNavItem v-for="item in nav" :key="item.text" :href="item.href">
        <i class="nav-icon icon icon-xl" :class="item.icon" />
        {{ item.text }}
      </CNavItem>

    </CSidebarNav>
  </div>
</template>